"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionType = void 0;
var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["SingleChoice"] = 1] = "SingleChoice";
})(QuestionType || (exports.QuestionType = QuestionType = {}));
